import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'uz',
  months: [
    'yanvar',
    'fevral',
    'mart',
    'aprel',
    'may',
    'iyun',
    'iyul',
    'avgust',
    'sentabr',
    'oktabr',
    'noyabr',
    'dekabr',
  ],
  monthsShort: ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'],
  weekdays: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba'],
  weekdaysMin: ['Y', 'D', 'S', 'C', 'P', 'J', 'S'],
  weekdaysShort: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
  formats: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    lt: 'H:mm',
    lts: 'H:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D-MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D-MMMM',
    LLL: 'YYYY-yil, D-MMMM H:mm',
    'LLL-Y': 'D-MMMM H:mm',
    LLLL: 'YYYY-yil, D-MMMM, dddd H:mm',
    'LLLL-Y': 'D-MMMM, dddd H:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM.',
    ll: 'D-MMM, YYYY',
    'll-Y': 'D-MMM',
    lll: 'YYYY-yil, D-MMM H:mm',
    'lll-Y': 'D-MMM H:mm',
    llll: 'YYYY-yil, D-MMM, ddd H:mm',
    'llll-Y': 'D-MMM, ddd H:mm',
    'll-Y+w': 'ddd, D-MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D-MMMM, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'TO', pm: 'TK', AM: 'TO', PM: 'TK' },
  past: {
    y: { one: '%s yil oldin', other: '%s yil oldin' },
    M: { one: '%s oy oldin', other: '%s oy oldin' },
    w: { one: '%s hafta oldin', other: '%s hafta oldin' },
    d: { one: '%s kun oldin', other: '%s kun oldin' },
    h: { one: '%s soat oldin', other: '%s soat oldin' },
    m: { one: '%s daqiqa oldin', other: '%s daqiqa oldin' },
    s: { one: '%s soniya oldin', other: '%s soniya oldin' },
  },
  future: {
    y: { one: '%s yildan keyin', other: '%s yildan keyin' },
    M: { one: '%s oydan keyin', other: '%s oydan keyin' },
    w: { one: '%s haftadan keyin', other: '%s haftadan keyin' },
    d: { one: '%s kundan keyin', other: '%s kundan keyin' },
    h: { one: '%s soatdan keyin', other: '%s soatdan keyin' },
    m: { one: '%s daqiqadan keyin', other: '%s daqiqadan keyin' },
    s: { one: '%s soniyadan keyin', other: '%s soniyadan keyin' },
  },
  abbr: {
    y: { one: '%s yil', other: '%s yil' },
    M: { one: '%s oy', other: '%s oy' },
    w: { one: '%s hafta', other: '%s hafta' },
    d: { one: '%s kun', other: '%s kun' },
    h: { one: '%s soat', other: '%s soat' },
    m: { one: '%s daq.', other: '%s daq.' },
    s: { one: '%s son.', other: '%s son.' },
  },
  justNow: 'Hozirgina',
  yesterday: 'Kecha',
  today: 'Bugun',
  tomorrow: 'Ertaga',
  weekStart: 1,
};
const localeName: LocaleName = 'uz';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'TO' : 'TO';
    } else {
      return isLowerCase ? 'TK' : 'TK';
    }
  },
};
